export default __webpack_public_path__ + "static/media/IMG_1429.3c6b9b27.jpg";